export const detectGoalTypeIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete goal type" || cleaned === "remove goal type") {
        return { intent: "delete_goal_type" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) goal type/);
    if (deleteMatch) {
        return { intent: "delete_goal_type", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create goal type") || cleaned.includes("add goal type")) {
        return { intent: "create_goal_type" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create goal type named (.+)/);
    if (createMatch) {
        return { intent: "create_goal_type", name: createMatch[1].trim() };
    }

    return null;
};
